import Button from '@sharedComponents/Button';
import FlexBox from '@sharedComponents/FlexBox';
import FormGroup from '@sharedComponents/FormGroup';
import InputText from '@sharedComponents/InputText';
import Select from '@sharedComponents/Select';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { getDatabaseNameOptions, getDomainOwnerOptions, getPlatformTypeOptions } from '../../helpers';

const PlatformFormPanel = ({ onCreate = () => {} } = {}) => {
    const { t } = useTranslation('bo');

    const methods = useForm({
        mode: 'onBlur',
        defaultValues: { url: '', type: 'RECETTE', databaseName: '', domainOwner: 'ETESTING' },
    });
    const { register, handleSubmit, control, setError, formState } = methods;

    const typeOptions = getPlatformTypeOptions(t);
    const domainOwnerOptions = getDomainOwnerOptions(t);
    const databaseOptions = getDatabaseNameOptions();

    const submit = async (data) => {
        // The shared Select carries no validation rules: the database has no safe default and must be picked.
        if (!data.databaseName) {
            setError('databaseName', { type: 'manual', message: t('Database is required') });
            return;
        }
        try {
            await onCreate({
                url: data.url.trim(),
                type: data.type,
                databaseName: data.databaseName,
                domainOwner: data.domainOwner,
            });
        } catch (err) {
            // Any other error is already surfaced as a toast by the caller.
            if (err?.status === 409) {
                setError('url', { type: 'manual', message: t('This URL is already used') });
            }
        }
    };

    return (
        <FormProvider {...methods}>
            <FlexBox flexDirection="column" gap="m">
                <form onSubmit={handleSubmit(submit)}>
                    <FlexBox flexDirection="column" gap="m">
                        <FormGroup label={t('Platform URL')} errorMsg={formState.errors.url?.message}>
                            <InputText {...register('url', { required: t('URL is required') })} isError={!!formState.errors.url} />
                        </FormGroup>
                        <FormGroup label={t('Platform type')}>
                            <Select control={control} register={{ name: 'type' }} options={typeOptions} isSearchable={false} />
                        </FormGroup>
                        <FormGroup label={t('Database')} errorMsg={formState.errors.databaseName?.message}>
                            <Select control={control} register={{ name: 'databaseName' }} options={databaseOptions} isSearchable />
                        </FormGroup>
                        <FormGroup label={t('Domain owner')}>
                            <Select
                                control={control}
                                register={{ name: 'domainOwner' }}
                                options={domainOwnerOptions}
                                isSearchable={false}
                            />
                        </FormGroup>
                    </FlexBox>
                </form>
                <FlexBox justifyContent="flex-end">
                    <Button label={t('Add platform')} action={handleSubmit(submit)} />
                </FlexBox>
            </FlexBox>
        </FormProvider>
    );
};

export default PlatformFormPanel;
